// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1J7d6","footer":"ReportModalFilter_footer__22wrz"};